import { Input } from "@progress/kendo-react-inputs";

export const PrefixProperty = {
  propertyName: "Prefix",
  propertyDisplay: "Prefix",
  propertyType: "string",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Input
        name={this.propertyName}
        onBlur={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || ""}
      />
    );
  },
};
